import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { catchError, lastValueFrom, map, Observable, Subscription, switchMap, take, throwError } from 'rxjs';
import { ReCaptchaResponse } from './models/ReCaptchaResponse';
import { CaptchaService } from './service/captcha.service';

@Component({
  selector: 'lib1-shared-recaptcha',
  templateUrl: './shared-recaptcha.component.html',
  styleUrls: ['./shared-recaptcha.component.scss'],
})
export class SharedRecaptchaComponent implements OnInit {
    
  @Output()
  sharedRecaptchaResultEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  showRecaptchaV2: boolean = false;

  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private captchaService: CaptchaService
  ) { }

  ngOnInit(): void {

    this.doRecaptchaCheckWrapper();
    
  }

  async doRecaptchaCheckWrapper() {

    //this needs to come from a flag
    let checkRecaptchaEnabled: boolean = true;//this.configService.app1ConfigSettings.checkRecaptchaEnabled;
    
    if (checkRecaptchaEnabled) {      

      try {

        let response = await lastValueFrom(this.doRecaptchaCheck().pipe(take(1)))

        if (response.success) {
                    
          //We PASSED v3 and its verified on server - no need to pass v2
          this.sharedRecaptchaResultEmitter.emit(true);  
        }
        

      } catch (e: any) {

        let statusCode: any = e.status;

        if (statusCode = 422) {

          this.showRecaptchaV2 = true;

        }

      } 

    } else {

      //We Don't want to check Recaptcha so we skip both v3 and v2
      this.sharedRecaptchaResultEmitter.emit(true);  

    }

  }


  doRecaptchaCheck(): Observable<any> {

    let retVal: ReCaptchaResponse;

    return this.recaptchaV3Service.execute('importantAction').pipe(

      switchMap(

        this.verifyTokenOnServer()

      ),

      map(

        (response: any) => {

          return response.reCaptchaResponse;

        },

      ),
      catchError((error: any) => {
        return throwError(() => error);
      })

    )

  }

  verifyTokenOnServer(): any {

    return (token: string) => {

      // this.tokenVisible = true;
      // this.reCAPTCHAToken = `Token [${token}] generated`;
      //let testMe = JSON.stringify(token);

      //POST TO VERIFY
      //https://developers.google.com/recaptcha/docs/verify
      //https://html.form.guide/snippets/google-recaptcha-javascript-validation/
      //https://codingsonata.com/google-recaptcha-v3-server-verification-in-asp-net-core-web-api/

      return this.captchaService.verifyTheTokenOnServer(token, "0.5", "6LdWnDclAAAAAJwZnC4exsUIGZBMjTrHSQGTWgV7")

    }

  }

  recaptchaV2ResultEmitterSubscriber(recaptchaV2Result: boolean): void {
    
    this.sharedRecaptchaResultEmitter.emit(recaptchaV2Result);
    
  }

}
